import { QUERY_KEYS } from 'api/query-keys';
import { flexPoolService } from 'ogp/services';
import { useQuery } from 'react-query';

const useGetFlexPoolsForCompany = () => {
  return useQuery(QUERY_KEYS.flexPoolsForCompany(), () => flexPoolService.getFlexPoolsForCompany());
};

export { useGetFlexPoolsForCompany };
